import React from "react";
import {
  Box,
  Stack,
  Chip,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  formatDateFromTimestamp,
  getContentOptions,
  getYear,
} from "../../utils/utils";

/**
 * One tracked item as a row in Track's list view (queued, started and stopped
 * tabs): title (and year), with when it entered its status on the right.
 *
 * @param {boolean} [showType] - Lead the title with the content type's icon,
 *   for the All tab, where types are mixed
 */
function LibraryList({ item, onClick, showType = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!item) return null;
  const { content_title, content_date, status_timestamp, content_type } = item;
  const date = content_type === "book" ? content_date : getYear(content_date);
  return (
    <Card onClick={onClick} elevation={0} width="100%">
      <CardActionArea>
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "space-between",
            p: "0px 4px",
            width: "100%",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            justifyContent={"flex-start"}
            alignItems={"center"}
            sx={{ flex: 1, minWidth: 0 }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ minWidth: 0 }}
            >
              {showType && getContentOptions()[content_type] && (
                <Box
                  component="span"
                  sx={{
                    display: "flex",
                    flexShrink: 0,
                    color: "text.secondary",
                    "& svg": { fontSize: isMobile ? 18 : 22 },
                  }}
                >
                  {getContentOptions()[content_type].icon}
                </Box>
              )}
              <Typography
                variant={isMobile ? "body1" : "h6"}
                sx={{
                  fontWeight: "bold",
                  minWidth: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {content_title}
              </Typography>
            </Stack>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{
                fontStyle: "italic",
                display: { xs: "none", md: "inline-flex" },
                pr: 1,
              }}
            >
              {date}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Chip
              label={formatDateFromTimestamp(status_timestamp)}
              size="small"
              sx={{
                backgroundColor: "transparent",
                color: "text.secondary",
                "& .MuiChip-label": {
                  pr: 0,
                },
              }}
            />
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default LibraryList;
